import { Component, OnInit } from '@angular/core';
import { ConstantsService } from '../services/constants.service';
import { environment } from "../../environments/environment"
import { AdminService } from '../services/admin.service';
import { Router } from '@angular/router';
import { UrlConstants } from '../services/url-constants';
import { DataService } from '../services/data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../confirmation/confirmation.component';
import { SessionService } from '../services/session.service';

@Component({
  selector: 'app-admin-curated',
  templateUrl: './admin-curated.component.html',
  styleUrls: ['./admin-curated.component.scss']
})
export class AdminCuratedComponent implements OnInit {
  videoTitle: any;
  public videos: any = [];
  public isChecked = false;
  public videoList = [];
  public profilePicture;
  public isLoading = false;
  public isProcessing = false;
  public isDisableLoadMore = true;
  public uploadSkeltonArray = [];
  public isdisabled = true;
  public isDisplayDropDown = false; // to display/hide dropdown
  public isDisplayFilterDropDown = false; // to display/hide filter dropdown
  public selectedSortBy = "";
  public startKey: any = null;
  public urlPrefix = environment.S3_URL_PRFIX;
  public folderName = this.constants.UPLOADEDTOVIEO_TXT;
  public sThreeFolder = 'pending';
  public isCuratedVideo = true;
  public curatedVideos = [];
  public offlineVideo = false;
  public curatedVideosArray = [];
  public from = "admin,curated";
  public isCurated = null;
  public message : string;
  public messageType: string;
  public isDisplayAlert :boolean=false;
  public title:string;
  public errorAlert = false;
  public errorAlertMessage = '';
  public successAlert = false;
  public successAlertMessage = '';
  public selectedSortOption=null;
  clickForward: boolean = true;
  lastEvaluatedKeyArr: any = [];
  filterCheckboxLabels = ["Interiors", "City", "Nature", "Animals", "Rain", "Snow", "Night", "Water", "DayVideo"];
  isDropDownOpen: boolean = false;
  isDropDownOpen1:boolean = false; //dropdown for sort by
  sortByOptions = [{key:"stats",value:"Views"},{key:"bookmarkCount",value:"Bookmarked"},{key:"createdAt",value:"Latest uploaded"}];
  sortByCuratedOptions = [{key:"stats",value:"Views"},{key:"bookmarkCount",value:"Bookmarked"},{key:"curatedAt",value:"Latest curated"}];
  
  selectedCheckboxes: { [key: string]: boolean } = {};
  selectedCount:number = 0;
  p: number = 1;
  isFiltersApplied = false;
  totalCount = 0;
  pageSize = 250;
  searchQuery:any;
  pageNumber = 1;
  asyncRetryCount = 0;
  isAsyncFetchCompleted = true;
  isFreeForApp: boolean = true;
  freeVideoCount = 0;
  constructor(
    private router: Router,
    public constants: ConstantsService,
    public adminservice:AdminService,
    public dataService :DataService,
    public urlConstants : UrlConstants,
    private modalService: NgbModal,
    private sessionService: SessionService
  ) { 
    var uploadSkelton = [
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
    ]
    this.uploadSkeltonArray = uploadSkelton;
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.isdisabled = true;
    const url = this.router.url;
    console.log("current url ",this.router.url);
    if(url.includes('curated/1')){
      this.title =  this.constants.UPLOADED_VIDEOS_TITLE //"Uploaded Videos"  //get all videos
   //   this.isCurated = false;
      this.selectedSortOption = "Latest uploaded";
      this.selectedSortBy ="createdAt";
      this.getCuratedVideos(false,false,true);
    }else{
      this.title = this.constants.CURATED_VIDEOS_TITLE //"Curated Videos" //get only curated videos
      this.isCurated = true;
      this.selectedSortOption = "Latest curated";
      this.selectedSortBy ="curatedAt";
      this.getCuratedVideos(true,false,true);
    }
    
  }
 
  getLastEvekey(data, postdata) {
    if (data['res'].searchAfter !== null) {
      postdata.searchAfter = data['res'].searchAfter;
      this.startKey = postdata.searchAfter;
    }
  }

  checkValue(event,item){
    this.selectedCheckboxes[item] = event.target.checked;
    this.isDisableLoadMore = true;
     // Increment or decrement selected count based on checkbox state
    if (event.target.checked) {
      this.selectedCount++;
    } else {
      this.selectedCount--;
    }
    this.isFiltersApplied = false;
  }

  checkSortValue(event,item){
    this.isDisableLoadMore = true;
    if (event.target.checked) {
      this.selectedSortBy = item.key;
      this.selectedSortOption = item.value;
      this.isDisplayDropDown = false;
      this.isDropDownOpen1 = false;
    } else {
      this.selectedSortBy = null;
      this.selectedSortOption = null;
    }
    this.checkForFilters();
  }

  formatCreatedAt(videos: any[]) {
    videos.forEach((item: any) => {
      if (item.uploadedAt) {
        const uploadedDate = new Date(item.uploadedAt);
        const day = uploadedDate.getDate();
        const month = uploadedDate.toLocaleString('en-US', { month: 'long' }); // Get full month name
        const year = uploadedDate.getFullYear();
        item.uploadedAtFormatted = `${day} ${month}, ${year}`;
      }
    });
  }

  getCuratedVideos(isCurated:boolean,isFiltered=false,initialiase=false){
    console.log("get curated videos list")
    this.isLoading = true;
    let params = [
      { param: '{actionName}', value: 'paginateAdminCurated' }  //TODO: change the actionanme paginateAdminCurated
    ]
    if(initialiase){
      this.startKey = null; //reset to get the results again
      this.videos = [];  
      this.pageNumber =1;
    }
    let postdata:any = isCurated ? {
      "campaignId": "window",
      "searchAfter": this.startKey !== null ? this.startKey : null,
      "isCurated":isCurated
    } : {
      "campaignId": "window",
      "searchAfter": this.startKey !== null ? this.startKey : null,
    }
    let queryParams = ""
    if(isFiltered){
      
      postdata = {
        ...postdata,
        filterBy:  Object.entries(this.selectedCheckboxes)
          .filter(([_, checked]) => checked)
          .map(([item]) => item),
      }
    }
    if(this.selectedSortBy){
      postdata = {
        ...postdata,
        sortBy:this.selectedSortBy
      }
    }
    if(this.searchQuery){
      postdata = {
        ...postdata,
        searchText : this.searchQuery 
      }
    }

    this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, params), postdata).subscribe((data: any) => {
      let { Items } = data.res;
      this.formatCreatedAt(Items);
      this.videos = [...this.videos, ...Items];
      this.sThreeFolder = 'uploadedToVimeo';
      this.curatedVideos = this.videos;
      this.getLastEvekey(data, postdata);
      this.clickForward ? this.lastEvaluatedKeyArr.push(data['res'].searchAfter) : '';
      if (data['res'].searchAfter === undefined) this.startKey = null;
      this.isLoading = false;
      if(Items.length < this.pageSize){
        this.isDisableLoadMore = true;
      }else{
        this.isDisableLoadMore = false;
      }
      
      this.totalCount = data['res'].Count;
      this.freeVideoCount = 0;
      this.curatedVideos.forEach((item) => {
        if(item.isFreeForApp){
          this.freeVideoCount++;
        }
      })
    }, (error) => {
      this.isLoading = false;
      this.errorAlert = true;
      this.errorAlertMessage = this.constants.FETCH_ERROR;
      
    })
    
   
  }

  Search() {
    this.getCuratedVideos(this.isCurated,this.isFiltersApplied,true)
  }

  SearchWithFilters(){
    this.isDisplayDropDown = false;
    this.isDisplayFilterDropDown = false;
    this.isDisableLoadMore = true;
    this.isDropDownOpen = false;
    this.isDropDownOpen1 = false;
    this.checkForFilters();
  }

  clearFilters(){
    this.selectedCheckboxes = {};
    this.selectedCount = 0;
    this.searchQuery = '';
    if(this.isCurated){
      this.selectedSortOption = "Latest curated";
      this.selectedSortBy ="curatedAt";
    } else {
      this.selectedSortOption = "Latest uploaded";
      this.selectedSortBy ="createdAt";
    }
    this.isDisplayDropDown = false;
    this.isDisplayFilterDropDown = false;
    this.isDropDownOpen = false;
    this.isDropDownOpen1 = false;
    this.isFiltersApplied = false;
    this.startKey = null;
    this.curatedVideos = [];
    this.isDisableLoadMore = true;
    this.getCuratedVideos(this.isCurated, false,true);
  }

  async onClickCurate(isCurate : boolean, selectedVideoId?: string){

    let selectedVideoToCurate = [{
      videoId: selectedVideoId
    }]
    
    if(isCurate){
      this.videoList.push(
        {
          videoId: selectedVideoId
        }
      );
      this.curatedVideos.map((item) => {
        if(item.videoId === selectedVideoId){
          item.isCurated = this.constants.CURATION_STATUS.pending;
        }
      })
    }else {
      this.isLoading = true;
    }
    if(this.videoList.length < 1){
      this.message = this.constants.SELECT_VIDEO_TXT;
      this.messageType = 'ERROR';
      this.isDisplayAlert = true;
    }
    else{
      
      const params = [
        { param: '{actionName}', value: 'updateCurated' }
      ]
      const postdata = {
        "campaignId": "window",
        "isCurated": isCurate,
        "videoList": isCurate ? selectedVideoToCurate :  this.videoList
      }

      this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, params), postdata).subscribe(async(data: any) => {
        
        if(isCurate){
          this.asyncRetryCount = 0;
          if(this.isAsyncFetchCompleted){
            await this.asyncCurationStatusFetch();       
          }
          return
        }else{
          this.successAlert = true;
          this.messageType = this.constants.SUCCESS;
          this.message = this.constants.UNCURATED_SUCCESS;
        }
        
        this.isDisplayAlert = true;
        this.videoList = [];
        let filtersApplied = this.selectedCount > 0 ? true : false;
        setTimeout(()=>{
        this.getCuratedVideos(!isCurate,filtersApplied,true);  //reseting the whole list
        },3000) 
      }, (error) => {
        this.isLoading = false;
        this.errorAlert = true;
        this.errorAlertMessage = this.constants.FETCH_ERROR;
        this.messageType = 'ERROR';
        this.message = this.constants.FETCH_ERROR;
        this.isDisplayAlert = true;
      })
    }
    
  }

  toggleFreeVideo(){
    let videoData = [];
    if(this.videoList.length > 10){
      this.message = this.constants.SELECT_10_VIDEO_TXT;
      this.messageType = 'ERROR';
      this.isDisplayAlert = true;
      return;
    }
    this.curatedVideos.map(item=>{
      if(this.videoList.some(video=>video.videoId === item.videoId)){
        let itemObj = {
          videoId: item.videoId,
          isFreeForApp: item.isFreeForApp ? true : false
        }
        videoData.push(itemObj)
      }
    })
    this.isLoading = true;
    const params = [
      { param: '{actionName}', value: 'toggleFreeVideoStatus' }
    ]
    const postdata = {
      "videoList": videoData
    }
    this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, params), postdata).subscribe((data: any) => {
      this.isLoading = false;
      this.successAlert = true;
      this.messageType = this.constants.SUCCESS;
      this.message = this.constants.SUCCESS;
      this.isDisplayAlert = true;
      this.videoList = [];
      let filtersApplied = this.selectedCount > 0 ? true : false;

      this.getCuratedVideos(this.isCurated,filtersApplied,true);  //reseting the whole list
    
    }, (error) => {
      this.isLoading = false;
      this.errorAlert = true;
      this.errorAlertMessage = this.constants.UPDATION_ERROR;
      this.messageType = 'ERROR';
      this.message = this.constants.UPDATION_ERROR;
      this.isDisplayAlert = true;
    })
  }

  checkForFilters(){
    
      this.resetFilterKeys(); 
      // this.videoList = [] //reset selected videos
      this.getCuratedVideos(this.isCurated, true,true);
    
  }

  resetFilterKeys(){
    this.isFiltersApplied = true;
    this.startKey = null; //reset the serachafter
    this.videos = []; //reset videos
    this.curatedVideos = [];
  }

  alertClose(){
    this.isDisplayAlert = false;
  }

  onClickName(video) {
    let email = video.emailId;
      let Name = video.author;
      let authorObj={
        "email":email,
        "name":Name,
      }
      this.sessionService.setItem('authorObj',authorObj);
      const url = this.router.createUrlTree(['./user/mywindow']).toString();
      window.open(url, '_blank');
  }

  onClickVideoTitle(item, event) {
    if(this.title === this.constants.UPLOADED_VIDEOS_TITLE){
      return
    }
    let shareUrl = `${window.location.origin}/Window/${item.videoId}`;
    navigator.clipboard.writeText(shareUrl).then(() => {
      window.open(`/Window/${item.videoId}`, '_blank');
    })
    document.getElementById(`${event.target.id}`).innerHTML = "URL copied"
  }
  onClickVideoThumbnail(item, event) {  
    if(this.title === this.constants.CURATED_VIDEOS_TITLE){
      return
    }
    let shareUrl = `${window.location.origin}/Window/${item.videoId}`;
    navigator.clipboard.writeText(shareUrl).then(() => {
      window.open(`/Window/${item.videoId}`, '_blank');
    })
  }

  onSelectTbleRow(video, event) {

    if (event.target.checked) {
      this.videoList.push({
        videoId: video.videoId,
        gazeUrl: video.gaze_vimeoUrl
      });
    } else {
      this.videoList = this.videoList.filter((data) => data.videoId !== video.videoId);
    }
    for (let i = 0; i < this.curatedVideos.length; i++) {
      if (video.videoId == this.curatedVideos[i].videoId) {
        this.curatedVideos[i].isChecked = event.target.checked;
        break;
      }
    }
  }

  toggleVisibility():void{
    if(!this.isLoading){
      this.isDropDownOpen1 = !this.isDropDownOpen1;
      this.isDisplayDropDown = this.isDropDownOpen1;
    }

  }

  toggleCheckboxVisibility(): void {
    if(!this.isLoading){
      this.isDropDownOpen = !this.isDropDownOpen;
      this.isDisplayFilterDropDown = this.isDropDownOpen;
    }
  }


  onPageChange(event){
    this.pageNumber = event;
  }

  paginateLoad(){
    this.isDisplayDropDown = false;
    this.isDisplayFilterDropDown = false;
    let filtersApplied = this.selectedCount > 0 ? true : false; 
    this.getCuratedVideos(this.isCurated,filtersApplied,false);
  }

  async asyncCurationStatusFetch() {

    this.isAsyncFetchCompleted = false;
    let params = [
      { param: '{actionName}', value: 'fetchVideoData' }
    ]
    let postdata: any = {
      videoList: this.videoList
    }

    try {
      let delay = (this.asyncRetryCount === 0) ? this.constants.ASYNC_CALL_TIME.INITIAL_INTERVAL : this.constants.ASYNC_CALL_TIME.INCREMENT_INTERVAL;
      await new Promise(resolve => setTimeout(resolve, delay));
      console.log('Going to fetch ..',this.videoList)
      let response: any = await this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, params), postdata).toPromise();
      let data = response?.res || [];
      let fetchedVideos : Array<any> = Object.values(data);

      let hasPendingCuration = fetchedVideos.filter(item => item.isCurated === this.constants.CURATION_STATUS.pending);
      let hasFailedCuration = fetchedVideos.filter(item => item.isCurated === this.constants.CURATION_STATUS.failed);
      let hasCompletedCuration = fetchedVideos.filter(item => item.isCurated === this.constants.CURATION_STATUS.curated);


      console.log("hasFailedCuration", hasFailedCuration);
      console.log("hasPendingCuration", hasPendingCuration);
      console.log("hasCompletedCuration", hasCompletedCuration);

      if(hasCompletedCuration.length > 0 ){
        this.videoList = this.videoList.filter((item) => !hasCompletedCuration.some(completedVideo => completedVideo.videoId === item.videoId));
        this.curatedVideos.map((item) => {
          if(hasCompletedCuration.some(completedVideo => completedVideo.videoId === item.videoId)){
            item.isCurated = this.constants.CURATION_STATUS.curated;
          }
        })
      }

      if (hasFailedCuration.length > 0) {
        
        this.videoList = this.videoList.filter((item) => !hasFailedCuration.some(failedVideo => failedVideo.videoId === item.videoId));
        this.curatedVideos.map((item) => {
          if(hasFailedCuration.some(failedVideo => failedVideo.videoId === item.videoId)){
            item.isCurated = this.constants.CURATION_STATUS.failed;
          }
        })
      }

      if (hasPendingCuration.length === 0 && this.videoList.length === 0) {
        console.log("No pending curation found");
        this.isLoading = false;

        this.message = this.constants.CURATION_COMPLETED;
        this.messageType = this.constants.SUCCESS;
        this.isDisplayAlert = true;

        this.videoList.length = 0;
        this.isAsyncFetchCompleted = true;
        return;
      }

      // if videos are in pending state : == >

      if (this.asyncRetryCount < this.constants.ASYNC_CALL_TIME.MAX_RETRIES) {
        this.asyncRetryCount++;
        console.log(`Retrying async curation status fetch, attempt ${this.asyncRetryCount}`);
        await this.asyncCurationStatusFetch();
      } else {

        this.message = this.constants.CURATION_TIMEOUT_ERROR_TXT;
        this.messageType = 'ERROR';
        this.isDisplayAlert = true;
      }

    } catch (error) {
      this.isLoading = false;
      this.errorAlert = true;
      this.message = this.constants.ASYNC_FETCH_ERROR;
      this.messageType = 'ERROR';
      this.isDisplayAlert = true;
      this.videoList.length = 0;
    }

  }


}
